// 环境地址
new Vue({
  el: '#app',
  delimiters: ['${', '}'],
  data: {
    regForm: {
      account: '',
      password: '',
      source: 1, // 1自然注册，2常规活动，3大型活动,4非官方页面
      country: '',
      platform: 'Shopify',
      action: 'register',
      act_id: 0,
    },
    bindForm: {
      account: shopify.email || '',
      orderno: '',
      type: 'platform',
      order_country: '',
    },
    countryOptions: [{
      value: 'US',
      label: 'Amazon.com'
    }, {
      value: 'CA',
      label: 'Amazon.ca'
    }, {
      value: 'UK',
      label: 'Amazon.co.uk'
    }, {
      value: 'FR',
      label: 'Amazon.fr'
    }, {
      value: 'DE',
      label: 'Amazon.de'
    }, {
      value: 'ES',
      label: 'Amazon.es'
    }, {
      value: 'IT',
      label: 'Amazon.it'
    }, {
      value: 'JP',
      label: 'Amazon.co.jp'
    }],
    tipsShow: false,
    activeSubmit: false,
    errorTip: '', // 错误提示
    successVisible: false,
    isLogin: false // 是否登录
  },
  created() {
    if (shopify.email) {
      this.regForm.account = shopify.email
      this.regForm.password = 'xxxxxxxx'
    }
  },
  methods: {
    // 提交事件
    submitHandle() {
      const rex = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]+$/
      const pattern = /^[0-9\d]{3}-([0-9\d]{7})-[0-9\d]{7}$/
      const pattern1 = /^S[0-9\d]{2}-([0-9\d]{7})-[0-9\d]{7}$/
      // 判断是否登录
      this.errorTip = '';
      // 校验account
      if (!this.regForm.account) {
        this.errorTip = 'Email is Empty'
        this.$refs.signEmail.focus()
        return
      } else if (!rex.test(this.regForm.account)) {
        this.errorTip = 'Your email address is invalid. Please enter avalid address.'
        this.$refs.signEmail.focus()
        return
      } else {
        this.errorTip = ''
      }

      // 校验password
      if (!this.regForm.password) {
        this.errorTip = 'Password is Empty'
        this.$refs.signPassword.focus()
        return
      } else if (this.regForm.password.length < 6) {
        this.errorTip = 'Use at least 6 characters'
        this.$refs.signPassword.focus()
        return
      } else {
        this.errorTip = ''
      }

      // 站点不能为空
      if (!this.bindForm.order_country) {
        this.errorTip = 'Please select the Amazon store.'
        this.$refs.signCountry.inputFocus()
        return
      }

      // 订单号格式
      if (!(pattern.test(this.bindForm.orderno) || pattern1.test(this.bindForm.orderno))) {
        this.errorTip = 'Please enter a valid order number.'
        this.$refs.signOrder.focus()
        return
      }
      this.activeSubmit = true
      shopify.id ? this.bindOrder() : this.sign() //登录态直接绑定订单，否则去登录
    },
    // 注册事件
    sign() {
      this.regForm.order_country = this.bindForm.order_country
      this.regForm.orderno = this.bindForm.orderno
      window.apis.register(this.regForm).then((res) => {
        const {account, password} = res
        //登录shopify
        window.apis.login({account, password}).then(() => {
          window.location.href = '/pages/my-order'
        }, (msg) => {
          this.activeSubmit = false
          this.errorTip = msg
        })
      }, (msg) => {
        this.activeSubmit = false
        this.errorTip = msg || 'register has failed'
      })
    },
    // 绑定订单信息
    bindOrder() {
      window.apis.bindOrder(this.bindForm).then((res) => {
        // 显示成功的弹出框
        if (res.code === 1) {
          // dataLayer.push({ 'event': 'warranty', 'category': 'warranty', 'operating': 'warranty_success' });
          this.tipsShow = true
          setTimeout(() => {
            window.location.href = '/pages/my-order'
          }, 3500)
        } else {
          this.activeSubmit = false
          this.errorTip = res.msg;
        }
        that.falg = false;
      }).catch(err => {
        this.activeSubmit = false
      })
    }
  }
})